"use client";

import FileUploader from "../../../components/common/FileUploader";
import InputField from "../../../components/common/InputField";
import { useLanguage } from "../../../context/LanguageContext";

const PayAdjust = () => {
  const { t } = useLanguage();
  return (
    <div className="w-full space-y-4">
      <InputField
        type="text"
        label={t("Enter transition number")}
        placeholder="6546dasd4as654654sad"
      />
      <FileUploader
        name="images"
        img="/img/upload-img.png"
        title={t("Upload Images")}
        message={t("you can upload pdf , png or jpg format only.")}
        classNameImgDiv="flex flex-col items-center justify-center"
        classNameMain="bg-white border"
      />
    </div>
  );
};

export default PayAdjust;
